import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webpractik/web/prod.webpractik.ru.w6p.ru/releases/167/components/features/cases/OldComponents/cases-new/rec/index.js");
